export default {
    blackList_00001: "Blacklist",
    blackList_00002: "Please enter user name/ mobile number",
    blackList_00003: "Once blacklisted, the user's micro signal, mobile phone number and other micro signals corresponding to the same mobile phone number will not be able to charge at the site",
    blackList_00004: "Reason",
    blackList_00005: "Please enter the reason for blacklisting the user, max 20 characters",
}